import { useQuery } from '@zg-rentals/react-query5';
import loadJsc from '../loadJsc';

export default function usePassiveAuth() {
  return useQuery({
    queryKey: ['passiveAuth'],
    queryFn: async () => {
      const globalWithAdx = global as typeof globalThis & {
        adx?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
      };

      if (!globalWithAdx.adx) {
        loadJsc();
      }

      const { adx } = globalWithAdx;

      return new Promise<{ jsc: string; hdimPayload: string }>((resolve) =>
        adx.initiate(() => {
          adx.validate('user_prefs');
          const jsc = (document.getElementById('user_prefs') as HTMLInputElement).value;
          const hdimPayload = (document.getElementById('user_prefs2') as HTMLInputElement).value;
          resolve({ jsc, hdimPayload });
        }),
      );
    },
  });
}
